<template>
  <UiCard>
    <div slot="title">Январь 2021</div>

    <div slot="content">
      <BarChart
        :chart-data="datacollection"
        :options="{
          legend: {
            display: false,
          },
          responsive: true,
          maintainAspectRatio: false,
        }"
      />
    </div>
  </UiCard>
</template>

<script>
import BarChart from '@/components/chart/charts/Bar.js'
import UiCard from '@/components/card/UiCard.vue'

export default {
  components: { UiCard, BarChart },
  data() {
    return {
      datacollection: {},
    }
  },
  mounted() {
    this.fillData()
  },
  methods: {
    fillData() {
      this.datacollection = {
        labels: [
          '01',
          '02',
          '03',
          '04',
          '05',
          '06',
          '07',
          '08',
          '09',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
          '22',
          '23',
          '24',
          '25',
          '26',
          '27',
          '28',
          '29',
          '30',
          '31',
        ],
        datasets: [
          {
            label: 'Label',
            backgroundColor: '#6E8DEC',
            borderWidth: 1,
            borderRadius: 5,
            data: [
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
              this.getRandomInt(),
            ],
          },
        ],
      }
    },
    getRandomInt() {
      return Math.floor(Math.random() * (50 - 5 + 1)) + 5
    },
  },
}
</script>
